import { render } from "./ThxInfoPostCreateView.vue?vue&type=template&id=0a61f04f&scoped=true"
import script from "./ThxInfoPostCreateView.vue?vue&type=script&lang=js"
export * from "./ThxInfoPostCreateView.vue?vue&type=script&lang=js"

import "./ThxInfoPostCreateView.vue?vue&type=style&index=0&id=0a61f04f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a61f04f"]])

export default __exports__